import { useEffect, useState } from 'react'

import { isNewerVersionDeployed } from '../services/appVersion'
import { onLiveResync } from '../services/signalr'

const CHECK_EVERY_MS = 5 * 60_000
/** عودة التبويب/النافذة تفحص فوراً — لكن ليس أكثر من مرة بالدقيقة */
const MIN_GAP_MS = 60_000

/**
 * يراقب نشر نسخةٍ أحدث والصفحة مفتوحة: كل 5 دقائق، وعند عودة الموظف للتبويب
 * أو للنافذة، وعند عودة الشبكة أو الاتصال الحيّ (النشر يعيد تشغيل الخادم).
 * يعيد true حين تتوفر نسخةٌ أحدث — ويتوقف الفحص بعدها.
 */
export function useNewVersionAvailable(): boolean {
  const [available, setAvailable] = useState(false)

  useEffect(() => {
    if (available) return
    let alive = true
    let lastCheck = 0
    const controller = new AbortController()

    const check = () => {
      if (document.visibilityState !== 'visible') return
      const now = Date.now()
      if (now - lastCheck < MIN_GAP_MS) return
      lastCheck = now
      void isNewerVersionDeployed(controller.signal).then((newer) => {
        if (alive && newer) setAvailable(true)
      })
    }
    const onVisible = () => check()

    const timer = window.setInterval(check, CHECK_EVERY_MS)
    document.addEventListener('visibilitychange', onVisible)
    window.addEventListener('focus', check)
    window.addEventListener('online', check)
    const offResync = onLiveResync(check)
    return () => {
      alive = false
      controller.abort()
      window.clearInterval(timer)
      document.removeEventListener('visibilitychange', onVisible)
      window.removeEventListener('focus', check)
      window.removeEventListener('online', check)
      offResync()
    }
  }, [available])

  return available
}
